import React, { Component } from 'react'
import classnames from 'classnames'
import { chain, zipObject, sortBy } from 'lodash'

import { utcToLocalDetailedDate } from '../../helpers/timeHelper'
import { displaySnakeCaseAsTitleCase } from '../../helpers/displayFormatHelper'

import { Card } from '../../components/card'
import { FraudCheck, FraudCheckProblem } from '../tasks/types'

export interface Props {
  fraudCheck: FraudCheck
}

interface ProblemGroup {
  type: string
  problems: FraudCheckProblem[]
}

export default class VehicleDetailsCarfax extends Component<Props> {
  static displayName = 'VehicleDetailsCarfax'

  render() {
    const { fraudCheck } = this.props
    if (!fraudCheck) return null

    const { flags, nonPersonalOwnership, problems, severeProblem } = fraudCheck

    const groupProblemsByType = (problems): ProblemGroup[] => {
      const sortedProblems = sortBy(problems, (problem) => {
        problem.type
      })
      let groupedProblems = chain(sortedProblems)
        .groupBy('type')
        .toPairs()
        .map((problems) => {
          return zipObject(['type', 'problems'], problems)
        })
        .value()

      return groupedProblems as unknown as ProblemGroup[] // TODO-TS
    }

    let problemCards
    if (problems) {
      const groupedProblemsArr = groupProblemsByType(problems)
      problemCards = groupedProblemsArr.map((mainProblem, index) => {
        const { problems, type } = mainProblem

        return (
          <tbody key={index}>
            <tr className="vehicle-details-carfax__table--header">
              <th>{displaySnakeCaseAsTitleCase(type)}</th>
            </tr>

            {problems.map((problem) => {
              const { firstDate, lastDate, firstState, name } = problem
              const dates =
                firstDate === lastDate
                  ? utcToLocalDetailedDate(firstDate)
                  : `${utcToLocalDetailedDate(
                      firstDate
                    )} - ${utcToLocalDetailedDate(lastDate)}`

              return (
                <tr
                  className="vehicle-details-carfax__table--row"
                  key={firstDate}
                >
                  <td>{type === 'TITLE' ? `${name} (${firstState})` : name}</td>
                  <td>{dates}</td>
                </tr>
              )
            })}
          </tbody>
        )
      })
    }

    const problemFlag = severeProblem ? 'Flagged' : 'Clean'
    const potentialFraudFlag = flags.length >= 1 ? 'Flagged' : 'Clean'
    const ownershipFlag = nonPersonalOwnership ? 'Other' : 'Personal'

    const specTitle = <div>CARFAX Review</div>

    return (
      <Card title={specTitle}>
        <table className="vehicle-details-carfax">
          <thead>
            <tr className="vehicle-details-carfax__table--row">
              <td>Severe problem component</td>
              <td>{severeProblem}</td>
              <td
                className={classnames('vehicle-details-carfax__status', {
                  'vehicle-details-carfax__status--flagged': severeProblem,
                })}
              >
                {problemFlag}
              </td>
            </tr>
            <tr className="vehicle-details-carfax__table--row">
              <td>Potential fraud file</td>
              <td
                className={classnames('vehicle-details-carfax__status', {
                  'vehicle-details-carfax__status--flagged': flags.length >= 1,
                })}
              >
                {potentialFraudFlag}
              </td>
            </tr>
            <tr className="vehicle-details-carfax__table--row">
              <td>Current ownership</td>
              <td
                className={classnames('vehicle-details-carfax__status', {
                  'vehicle-details-carfax__status--flagged':
                    nonPersonalOwnership,
                })}
              >
                {ownershipFlag}
              </td>
            </tr>
          </thead>
          {problems && problemCards}
        </table>
      </Card>
    )
  }
}
